import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { jsx } from '@emotion/react';
import { forwardRef } from 'react';
import { Input } from '../Input/Input.es.js';
import { labelStyles, withModifier } from '@zapier/style-encapsulation';

const Styles = labelStyles("TextInput", {
  input: (props) => [
    // FireFox puts an arbitrary min-width on the input otherwise
    { minWidth: 1 },
    props.isMultiline && withModifier("multiline", {
      height: "auto"
    }),
    props.isFullWidth && withModifier("fullwidth", {
      width: "100%"
    }),
    props.resize && withModifier(`resize-${props.resize}`, {
      resize: props.resize
    })
  ]
});
const TextInput = forwardRef((_a, ref) => {
  var { defaultValue, isMultiline = false, type = "text", isFullWidth = false, size = "small", borderRadius = 3 } = _a, otherProps = __rest(_a, ["defaultValue", "isMultiline", "type", "isFullWidth", "size", "borderRadius"]);
  const props = Object.assign({
    isMultiline,
    type,
    isFullWidth,
    size,
    borderRadius
  }, otherProps);
  const Tag = props.isMultiline ? "textarea" : "input";
  return jsx(Input, Object.assign({}, props, { renderIconAfter: props.isMultiline ? void 0 : props.renderIconAfter, renderIconBefore: props.isMultiline ? void 0 : props.renderIconBefore }), (inputProps) => jsx(Tag, Object.assign({}, inputProps, { autoCapitalize: props.autoCapitalize, autoCorrect: props.autoCorrect, css: [inputProps.css, Styles.input(props)], defaultValue, inputMode: props.inputMode, ref, rows: props.isMultiline ? props.rows : void 0, spellCheck: props.spellCheck, type: !props.isMultiline ? props.type : void 0, value: inputProps.value, onChange: inputProps.onChange, "data-zds": true })));
});

export { TextInput };
//# sourceMappingURL=TextInput.es.js.map
